// extracted by mini-css-extract-plugin
module.exports = {"Task":"TaskListItem_Task_3fRXl","TaskLabel":"TaskListItem_TaskLabel_2pQ7X","TaskDetails":"TaskListItem_TaskDetails_1Y7lg"};